export const en = {
    "socialMedia": {
        "facebook": "https://www.facebook.com/investturkey",
        "instagram": "https://www.instagram.com/investinturkiye_en",
        "linkedin": "https://www.linkedin.com/company/invest-in-turkey",
        "x": "https://twitter.com/InvestTurkey",
        "youtube": "https://www.youtube.com/c/InvestinT%C3%BCrkiye"
    },
    "heroSection": {
        "tagline": "2024-2028",
        "heading": "Foreign Direct Investment Strategy",
        "description": "This strategic roadmap aims to attract high-quality FDI investments that align with Türkiye's economic development goals amid a rapidly changing global economic environment."
    },
    "headerMenu": {
        "currentLanguage": {
            "code": "EN",
            "icon": ""
        },
        "optionalLanguages": [
            {
                "code": "TR",
                "label": "Turkish",
                "icon": "",
                "link": "/tr"
            }
        ],
        "menuItems": [
            {
                "name": "HOME",
                "link": "/",
                "icon": null
            },
            {
                "name": "WHO WE ARE",
                "link": "https://www.invest.gov.tr/en/pages/who-we-are.aspx",
                "icon": null,
                "openNewTab":true
            }
        ],
        "mobileMenuButton": {
            "icon": "",
            "label": "Menu"
        },
        "discoverButton": {
            "text": "Discover Opportunities",
            "link": "/listing",
            "icon": ""
        },
        "downloadButton": {
            "text": "Download PDF",
            "link": "https://www.invest.gov.tr/en/Documents/turkiye-foreign-direct-investment-strategy-2024-2028.pdf",
            "icon": ""
        }
    },
    "form": {
        "placeholder": "Your email address..",
        "submitText": "Get Started",
        "successMessage": "Thank you! Your submission has been received!",
        "errorMessage": "There was an issue submitting your form. Please try again."
    },
    "footerMenu": {
        "logoLink": "/",
        "downloadPdf": {
            "text": "Download PDF",
            "link": "https://www.invest.gov.tr/en/Documents/turkiye-foreign-direct-investment-strategy-2024-2028.pdf",
            "icon": ""
        },
        "menuItems": [
            {
                "title": "HOME",
                "link": "/"
            },
            {
                "title": "FDI INSIGHTS",
                "link": "/insights",
                "subLinks": [
                    {
                        "title": "FDI Outlook & Trends",
                        "link": "/insights#fdi-outlook"
                    },
                    {
                        "title": "Performance & Ecosystem",
                        "link": "/insights#fdi-performance"
                    },
                    {
                        "title": "Key Findings",
                        "link": "/insights#key-findings"
                    },
                    {
                        "title": "Quality FDI",
                        "link": "/insights#quality-fdi"
                    }
                ]
            }
        ],
        "actionPlan": {
            "title": "FINANCIAL RESOURCES",
            "link": "/action-plans",
            "subLinks": [
                {
                    "title": "Venture Capital Investment Funds",
                    "link": "/action-plans#01"
                },
                {
                    "title": "Angel Investment Networks",
                    "link": "/action-plans#02"
                },
                {
                    "title": "Accelerators and Incubators",
                    "link": "/action-plans#03"
                },
                {
                    "title": "Investors/Funds",
                    "link": "/action-plans#04"
                },
                {
                    "title": "Corporate Venture Capital",
                    "link": "/action-plans#05"
                },
                {
                    "title": "Impact Investment and Impact-Oriented Funds",
                    "link": "/action-plans#06"
                },
                {
                    "title": "Crowdfunding Platforms",
                    "link": "/action-plans#06"
                },
                {
                    "title": "Grants and Support Mechanisms",
                    "link": "/action-plans#06"
                }
            ]
        }
    },
    "DiscoverResources": {
        "tagline": 'TURKISH INVESTMENT ECOSYSTEM',
        "heading": 'Discover Financial Resources',
        "paragraph": 'Welcome to your gateway for accessing financial resources in Türkiye for your venture. This platform is designed to help you discover available investment opportunities and develop a successful funding strategy.',
        "buttonText": 'Discover Opportunities'
    },
    "HeroCards": {
        "card1": {
            "title": "Venture Capital<br />Investment Funds",
            "description": "144 Funds",
            "link": "#"
        },
        "card2": {
            "title": "Angel Investors",
            "description": "Coming Soon",
            "link": "#"
        },
        "card3": {
            "title": "$ 400",
            "description": "Lorem ipsum Dolor sit Amet.",
            "link": "#"
        },
        "card4": {
            "title": "0",
            "description": "Lorem ipsum Dolor sit Amet.",
            "link": "#"
        },
        "card5": {
            "title": "Crowdfunding<br />Platforms",
            "description": "Coming Soon",
            "link": "#"
        },
        "card6": {
            "title": "0",
            "description": "Lorem ipsum Dolor sit Amet.",
            "link": "#"
        },
        "card7": {
            "title": "0",
            "description": "Lorem ipsum Dolor sit Amet.",
            "link": "#"
        },
        "card8": {
            "title": "Acceleration<br />Centers",
            "description": "Coming Soon",
            "link": "#"
        }
    },
    "testimonials": [
        {
            "quote": "Less than three years ago, bunq, a European unicorn neobank, established its presence in Türkiye. Since then, we have built a strong team of over 120 professionals, with an average age of below 28. We were drawn by Türkiye’s dynamic, mobile-literate population and its rich pool of open-minded, ambitious, and highly educated young talent. Our people-centric and user- focused team embodies the Turkish spirit of hospitality, treating every user as a valued guest — a cornerstone of the local culture. This mindset drives exceptional energy, agility, and innovation. Türkiye continues to play a pivotal role in advancing bunq’s mission to make banking truly free and in fueling our ongoing growth across Europe and beyond.",
            "name": "Hüseyin Demirhisar",
            "title": "Bunq, Head of Operations/Expansion",
            "avatar": "/images/consultants/huseyin-demirhisar.webp",
            "episodes": {
                "spotify": "",
                "youtube": "",
                "apple": ""
            }
        },
        {
            "quote": "Türkiye has changed drastically. Previously, we were just a group of venture capitalists doing business together. Now there are 43 more European-based venture capital firms and almost 344 Turkish VC firms, such as GSFA and GSYF. There are so many VCs and a lot of dry powder in the market.",
            "name": "Cenk Bayrakdar",
            "title": "Revo Capital Founding Partner & Managing Director",
            "avatar": "/images/consultants/cenk-bayrakdar.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-02-spotify",
                "youtube": "https://invest.tr/talks-02-youtube",
                "apple": "https://invest.tr/talks-02-apple"
            }
        },
        {
            "quote": "We believe the Turkish market is a great test market. It has many large and small players of different sizes and industries to test a product, but it is not big enough to turn a company into a global success story. That is why we urge startups to test their products and teams and go global as soon as possible. This is the reason we exist.",
            "name": "Ali Karabey",
            "title": "212 VC-Founding Partner & Managing Director",
            "avatar": "/images/consultants/ali-karabey.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-16-spotify",
                "youtube": "https://invest.tr/talks-16-youtube",
                "apple": "https://podcasts.apple.com/tr/podcast/16-the-essence-of-venture-capitalism-in-t%C3%BCrkiye-with/id1767459449?i=1000682174887"
            }
        },
        {
            "quote": "Our talent base is definitely our greatest strength, both within Türkiye and among our diaspora around the world. Here in Türkiye, we have one of the fastest-growing engineering talent pools.",
            "name": "Dilek Dayınlarlı",
            "title": "ScaleX Ventures-Founder & Managing Partner",
            "avatar": "/images/consultants/dilek-dayinlarli.webp",
            "episodes": {
                "spotify": "https://open.spotify.com/episode/4rxewT5f8D8Tl3TZDjtfIs",
                "youtube": "https://invest.tr/talks-12-youtube",
                "apple": "https://podcasts.apple.com/tr/podcast/12-scaling-success-navigating-growth-journey-of/id1767459449?i=1000678963061"
            }
        },
        {
            "quote": "I am more focused on finding the right people who can position me in the right tailwinds, rather than trying to identify those tailwinds myself. My priority is to connect with the best people who can help make that happen.",
            "name": "Enis Hulli",
            "title": "e2vc-General Partner",
            "avatar": "/images/consultants/enis-hulli.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-11-spotify",
                "youtube": "https://invest.tr/talks-11-youtube",
                "apple": "https://invest.tr/talks-11-apple"
            }
        },
        {
            "quote": "Now there are more eager investors to invest in, especially in venture capital, alongside us, and we have made partnership agreements with esteemed organizations such as Teknopark Istanbul and Bilişim Vadisi, which are technoparks in Türkiye. This is why we have been more active in the venture capital area in the last year.",
            "name": "Murat Onuk",
            "title": "Managing Partner at Arz Portföy",
            "avatar": "/images/consultants/Murat-Onuk.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-19-spotify",
                "youtube": "https://invest.tr/talks-19-youtube",
                "apple": "https://invest.tr/talks-19-apple"
            }
        },
        {
            "quote": "Deep-tech opportunities are those businesses whose competitive edge stems from technological superiority. Almost every business opportunity today is related to technology. But what sets deep-tech apart is that these opportunities must derive their competitive edge from technological superiority.",
            "name": "Altan Küçükçınar",
            "title": "Diffusion Capital Partners (DCP)- Partner",
            "avatar": "/images/consultants/altan-kucukcinar.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-15-spotify",
                "youtube": "https://invest.tr/talks-15-youtube",
                "apple": "https://invest.tr/talks-15-apple"
            }
        },
        {
            "quote": "In terms of outcomes, out of the seven unicorns from Türkiye, four are led by female founders. The success rate is quite high. If we achieved these results despite limited access to capital for female entrepreneurs, imagine what we could accomplish with more capital.",
            "name": "Ahu Serter",
            "title": "Arya Women Investment Platform and Fark Labs-Founder",
            "avatar": "/images/consultants/ahu-serter.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-04-spotify",
                "youtube": "https://invest.tr/talks-04-youtube",
                "apple": "https://invest.tr/talks-04-apple"
            }
        },
        {
            "quote": "Türkiye stands as one of the most powerful development ecosystems in the world for mobile gaming. I can confidently say that we rank among the top five in terms of the number of game developers and talented people in this field.",
            "name": "Barış Özistek",
            "title": "Boğaziçi Ventures-Managing Partner",
            "avatar": "/images/consultants/baris-ozistek.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-06-spotify",
                "youtube": "https://invest.tr/talks-06-youtube",
                "apple": "https://invest.tr/talks-06-apple"
            }
        },
        {
            "quote": "You have to find new ways, new instruments to change mindsets, and that requires a new paradigm. Impact investing or sustainable finance introduces that new paradigm.",
            "name": "Şafak Müderrisgil",
            "title": "EYDK Executive Board Chair",
            "avatar": "/images/consultants/safak-muderrisgil.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-21-spotify",
                "youtube": "https://invest.tr/talks-21-youtube",
                "apple": "https://invest.tr/talks-21-apple"
            }
        },
        {
            "quote": "Türkiye is a fascinating country with millions of companies. Every year, thousands of new ventures emerge and become investable. We continuously generate new initiatives across every sector, providing investors with a diverse range of options.",
            "name": "Barış Öney",
            "title": "GlobalTurk Capital-Founder and Managing Partner",
            "avatar": "/images/consultants/baris-oney.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-07-spotify",
                "youtube": "https://invest.tr/talks-07-youtube",
                "apple": "https://invest.tr/talks-07-apple"
            }
        },
        {
            "quote": "Our goal is not to be an exchange, but to focus on interoperability, acting as a bridge between traditional finance and decentralized finance.",
            "name": "Egem Eraslan",
            "title": "CEO of Midas",
            "avatar": "/images/consultants/Egem-Eraslan.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-18-spotify",
                "youtube": "https://invest.tr/talks-18-youtube",
                "apple": "https://invest.tr/talks-18-apple"
            }
        },
        {
            "quote": "If you come to Türkiye, you will find that Turkish startups are among the most resilient worldwide. The economy poses challenges, competition is intense, and accessing capital is not easy at all. Despite the increasing number of venture capitalists entering the scene, we still lack sufficient capital at present. Therefore, entrepreneurs truly understand the value of every dollar.",
            "name": "Ata Uzunhasan",
            "title": "Galata Business Angels-Managing Director",
            "avatar": "/images/consultants/ata-uzunhasan.webp",
            "episodes": {
                "spotify": "https://invest.tr/talks-13-spotify",
                "youtube": "https://invest.tr/talks-13-youtube",
                "apple": "https://invest.tr/talks-13-apple"
            }
        }
    ],
    "keyTrends": {
        "tagline": "FDI STRATEGY",
        "heading": "Explore Türkiye’s Thriving Startup Ecosystem",
        "description": "Learn about Türkiye's startup ecosystem with valuable content.",
        "slides": [
            {
                "tagline": "MICRO WEBSITE",
                "title": "Explore Türkiye's FDI Strategy",
                "description": "",
                "button": "Explore Strategy",
                "link":"https://fdistrategy.gov.tr/",
                "backTitle": "Explore Türkiye's FDI Strategy",
                "backDescription": "Türkiye's FDI Strategy 2024-2028 is now live. Explore the platform that offers a comprehensive overview of the insights and key findings that have shaped Türkiye's FDI Strategy, including the latest FDI outlook, key trends, performance metrics, and ecosystem analysis.",
                "backButton": "Explore"
            },
            {
                "tagline": "REPORT",
                "title": "Türkiye's Startup Ecosystem Report",
                "description": "",
                "button": "Explore Report",
                "link":"https://www.invest.gov.tr/en/library/publications/lists/investpublications/the-state-of-turkish-startup-ecosystem-2025.pdf",
                "backTitle": "Türkiye's Startup Ecosystem Report",
                "backDescription": "The report highlights the resilience and innovation within the Turkish startup landscape, positioning it as a vibrant hub for entrepreneurship. Explore the dynamic startup ecosystem in Türkiye and learn how innovation and investment are driving growth.",
                "backButton": "Explore"
            },
            {
                "tagline": "REPORT",
                "title": "Türkiye's Gaming Ecosystem Report",
                "description": "",
                "button": "Explore Report",
                "link":"https://www.invest.gov.tr/en/library/publications/lists/investpublications/the-state-of-turkish-gaming-ecosystem-2025.pdf",
                "backTitle": "Türkiye's Gaming Ecosystem Report",
                "backDescription": "Türkiye is one of the five European countries with gaming unicorns, featuring two unicorns! Discover why Türkiye is a global player in the gaming industry and a hub for talent with its groundbreaking startups.",
                "backButton": "Explore"
            },
            {
                "tagline": "REPORT",
                "title": "Türkiye's Fintech Ecosystem Report",
                "description": "",
                "button": "Explore Report",
                "link":"https://www.invest.gov.tr/en/library/publications/lists/investpublications/the-state-of-turkish-fintech-ecosystem-2025.pdf",
                "backTitle": "Türkiye's Fintech Ecosystem Report",
                "backDescription": "Türkiye is rapidly becoming a regional fintech hub with 835 active fintech companies and 82 licensed payment & e-money institutions. Discover why Türkiye stands out in digital finance with its fast-growing fintech ecosystem.",
                "backButton": "Explore"
            },
            {
                "tagline": "MICRO WEBSITE",
                "title": "Explore the FDI Glossary",
                "description": "",
                "link":"https://fdiglossary.invest.gov.tr/",
                "button": "Discover Glossary",
                "backTitle": "Explore the FDI Glossary",
                "backDescription": "Unlock the language of investment with Invest in Türkiye's 'Foreign Direct Investment Glossary'! Explore definitions of key terms in the entrepreneurship ecosystem. Discover more!",
                "backButton": "Discover"
            },
            {
                "tagline": "REPORT",
                "title": "Türkiye Destination for Early-Stage Investments",
                "description": "",
                "link":"https://www.invest.gov.tr/tr/library/publications/lists/investpublications/turkiye-erken-asama-yatirimlar-icin-destinasyon.pdf",
                "button": "Explore Report",
                "backTitle": "Türkiye Destination for Early-Stage Investments",
                "backDescription": "Discover Türkiye's potential as the nexus of early-stage investments, highlighting strong performance in seed-stage deals and thriving sectors.",
                "backButton": "Explore"
            }
        ]
    },
    "listing": {
        "allFinancialResources": "All Financial Resources",
        "startupStage": "Investment Stage",
        "organizationsAvailable": "{{count}} Funds Found",
        "sorting": "Sort by",
        "alphabeticalOrder": "Alphabetical Order",
        "fromAToZ": "From A to Z",
        "startupArea": "Focus Area",
        "selectionsMade": "{{count}} Selected Items",
        "all": "All",
        "noResultsFound": "No Results Found",
        "dealSize": "Deal Size",
        "fundSize": "Fund Size",
        "getDetailedInfo": "Get Detailed Info",
        "otherFilters": "Other Filters",
        "turkeyBasedResources": "Turkey-Based Resources",
        "organizationsBasedInTurkey": "Organizations Based in Turkey",
        "governmentInstitutions": "Government Institutions",
        "stateSupportedResources": "State-Supported Resources",
        "reset": "Reset",
        "featureYourFundHere": "Feature Your Fund Here",
        "missingFundPrompt": "Is your fund missing? <br/> Submit Your Fund",
        "featureYourFund": "Feature Your Fund",
        "readMore": "Add Focus Area",
        "selectCategory": "Select Category",
        "categoriesAvailable": "{{count}} Categories Available",
        "sectorIndependent": "Sector Independent",
        "confirmSelection": "Confirm Selection",
        "search": "Search",
        "alphabetical": "Alphabetical",
        "byFundSize": "By Fund Size",
        "largeToSmall": "Large to Small",
        "byDealSize": "By Deal Size",
        "smallToLarge": "Small to Large",
        "byEstablishmentDate": "By Establishment Date",
        "newToOld": "New to Old",
        "focusAreas": "FOCUS AREAS",
        "fundHeadquarters": "Fund Headquarters",
        "yearOfEstablishment": "Year of Establishment",
        "geographicalInvestmentPreference": "Geographical Investment Preference"
    }
}